export const environment = {
  apiBaseUrls : {
    awsApiGateway: 'https://insights-qa.wsldev.com'
  },
  apiUrl: "https://insights-qa.wsldev.com",
  production: true
};
